import React, { useState, useEffect, useRef } from "react";

import { categoryHotkey } from "./labels";

const LabelPicker = ({ state, categories, onPick, onClose }) => {
  const containerRef = useRef(null);
  const [search, setSearch] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (state.visible) {
      setSearch("");
      setSelectedIndex(0);
    }
  }, [state.visible]);

  useEffect(() => {
    if (!state.visible) return;

    const onOutsideMouseDown = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) onClose();
    };

    document.addEventListener("mousedown", onOutsideMouseDown);
    return () => document.removeEventListener("mousedown", onOutsideMouseDown);
  }, [state.visible, onClose]);

  if (!state.visible) return null;

  const filtered = categories.filter((category) => category.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div
      ref={containerRef}
      className="fixed z-50 w-64 rounded-lg border border-gray-200 bg-white shadow-lg"
      style={{ top: `${Math.min(state.y, window.innerHeight - 320)}px`, left: `${Math.min(state.x, window.innerWidth - 270)}px` }}
    >
      <input
        type="text"
        name="labelSearch"
        aria-label="Rechercher un label"
        value={search}
        onChange={(event) => {
          setSearch(event.target.value);
          setSelectedIndex(0);
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter" && filtered.length > 0) onPick(filtered[Math.min(selectedIndex, filtered.length - 1)]);
          if (event.key === "Escape") onClose();
          if (event.key === "ArrowUp") {
            event.preventDefault();
            setSelectedIndex((previous) => (previous > 0 ? previous - 1 : filtered.length - 1));
          }
          if (event.key === "ArrowDown") {
            event.preventDefault();
            setSelectedIndex((previous) => (previous < filtered.length - 1 ? previous + 1 : 0));
          }
        }}
        placeholder="Rechercher un label…"
        className="w-full border-b border-gray-100 px-3 py-2 text-sm outline-none placeholder:text-gray-400"
        autoFocus
      />
      <div className="max-h-64 overflow-y-auto p-1" role="list">
        {filtered.map((category, index) => (
          <button
            key={category.name}
            type="button"
            className={`flex w-full items-center gap-2.5 rounded-md px-2 py-1.5 text-left text-sm text-gray-700 ${index === selectedIndex ? "bg-gray-100" : "hover:bg-gray-50"}`}
            onMouseEnter={() => setSelectedIndex(index)}
            onClick={() => onPick(category)}
          >
            <span className={`h-2 w-2 shrink-0 rounded-full ${category.bg}`} />
            <span className="min-w-0 flex-1 truncate">{category.name}</span>
            <kbd className="shrink-0 rounded border border-gray-200 bg-gray-50 px-1 font-sans text-[10px] uppercase text-gray-500">
              {categoryHotkey(category.key).startsWith("shift+") ? `⇧${category.key}` : category.key}
            </kbd>
          </button>
        ))}
        {filtered.length === 0 && <div className="px-2 py-2 text-sm text-gray-400">Aucun label</div>}
      </div>
    </div>
  );
};

export default LabelPicker;
